import { Component } from '@angular/core';

@Component({
  selector: 'app-solutions',
  standalone: false,
  templateUrl: './solutions.html',
  styleUrl: './solutions.css'
})
export class Solutions {

}
